import { render, staticRenderFns } from "./QRCScanner.vue?vue&type=template&id=64d36a6a&scoped=true&"
import script from "./QRCScanner.vue?vue&type=script&lang=js&"
export * from "./QRCScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRCScanner.vue?vue&type=style&index=0&id=64d36a6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d36a6a",
  null
  
)

export default component.exports